require.register("app/restaurant/supplier/DeliveryForm", function(exports, require, module){
  $0
  
});

